import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class JudgesFilter {
  public search: string = ''
  public paging: PaginationRequest = new PaginationRequest()
}
